/* src/components/Navbar.jsx */
import {
  Box,
  Flex,
  HStack,
  VStack,
  Text,
  Button,
  Image,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import {
  getUserById,
  getCustomerById,
  fetchCustomerRoles,
} from "../../services/api";

const CUSTOMER_VERSION_KEY = "customerVersion";

export default function Navbar() {
  const navigate = useNavigate();

  /* ▸ stato locale ---------------------------------------------------- */
  const [userName, setUserName] = useState("Caricamento…");
  const [customerDiscount, setCustomerDiscount] = useState(null); // es: 12
  const [custVersion, setCustVersion] = useState(
    JSON.parse(localStorage.getItem(CUSTOMER_VERSION_KEY)) || false
  );

  /* ▸ fetch utente + sconto una tantum ------------------------------- */
  useEffect(() => {
    (async () => {
      const stored = JSON.parse(localStorage.getItem("user"));
      if (!stored?.id) {
        setUserName("Ospite");
        return;
      }

      try {
        /* 1) user */
        const { data: userData } = await getUserById(stored.id);
        setUserName(userData.name || "Utente");

        /* 2) customer role → discount */
        const { data: custData } = await getCustomerById(userData.customer_id);
        const { data: roleData } = await fetchCustomerRoles(
          custData.customer_role_id
        );

        const disc = Number(roleData.discount);
        setCustomerDiscount(!isNaN(disc) ? Math.abs(disc) : null);
      } catch (err) {
        console.error("Errore caricamento navbar:", err);
        setCustomerDiscount(null);
      }
    })();
  }, []);

  /* ▸ ascolto toggle “versione cliente” ------------------------------ */
  useEffect(() => {
    /* evento custom lanciato da CreateQuote */
    const handleCustom = (e) => setCustVersion(!!e.detail);

    /* variazione localStorage (altra tab) */
    const handleStorage = () =>
      setCustVersion(
        JSON.parse(localStorage.getItem(CUSTOMER_VERSION_KEY)) || false
      );

    window.addEventListener("customerVersionChanged", handleCustom);
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("customerVersionChanged", handleCustom);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  /* ▸ valore visualizzato ------------------------------------------- */
  const shownDiscount =
    customerDiscount == null
      ? "—"
      : custVersion
      ? "0 %"
      : `${customerDiscount}%`;

  /* ▸ logout --------------------------------------------------------- */
  const handleLogout = () => {
    localStorage.clear();
    navigate("/", { replace: true });
  };

  /* ▸ UI ------------------------------------------------------------- */
  return (
    <Box
      as="nav"
      w="100%"
      pos="fixed"
      zIndex="popover"
      bg="white"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      {/* riga logo + info utente */}
      <Flex px={6} align="center" justify="space-between" h="88px">
        <HStack gap={3} align="center">
          <Image
            src="/assets/e-Zen_Logo-Color.png"
            boxSize="80px"
            objectFit="contain"
          />
          <Text fontSize="3xl" fontWeight="bold">
            e-Zen Configurator
          </Text>
        </HStack>

        <HStack
          spacing={6}
          align="center"
          pt="2%"
          borderWidth="2px"
          borderRadius="2xl"
          p={6}
          mt={6}
          boxShadow="xl"
        >
          <VStack spacing={0} align="flex-start">
            <Text>
              Utente:&nbsp;<b>{userName}</b>
            </Text>

            <Text>
              Sconto cliente:&nbsp;<b>{shownDiscount}</b>
            </Text>

            <Button
              variant="link"
              fontWeight="bold"
              size="sm"
              color="gray.600"
              onClick={handleLogout}
              _hover={{ textDecoration: "underline" }}
            >
              Logout
            </Button>
          </VStack>
        </HStack>
      </Flex>

      {/* riga link navigazione */}
      <Flex px={6} py={2} align="center">
        <HStack spacing={4}>
          {[
            { to: "/create-quote", label: "Crea Quotazione" },
            { to: "/quotes", label: "Storico Quotazioni" },
            { to: "/profile", label: "Profilo Utente" },
          ].map((l) => (
            <Button
              key={l.to}
              as={Link}
              to={l.to}
              variant="ghost"
              size="sm"
              _hover={{ textDecoration: "underline" }}
            >
              {l.label}
            </Button>
          ))}
        </HStack>
      </Flex>
    </Box>
  );
}
